
import data from "@/mixins/data.js"

export default {
  name: "StepTab4",
  mixins: [data],
}
